import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b650943"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-bar-chart fa-lg fa-fw",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "side-menu-item-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-cogs fa-lg fa-fw",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "side-menu-item-name" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const isDashboardActive = computed(() => route.path === '/dashboard');
const isServicesActive = computed(() => route.path.indexOf('/services') === 0);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/dashboard",
      class: _normalizeClass(["side-menu-item", { 'side-menu-item-active': _unref(isDashboardActive) }]),
      "aria-label": _ctx.$t('Dashboard')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["side-menu-item-icon", { 'side-menu-item-icon-active': _unref(isDashboardActive) }])
        }, _hoisted_3, 2),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Dashboard')), 1)
      ]),
      _: 1
    }, 8, ["class", "aria-label"]),
    _createVNode(_component_router_link, {
      to: "/services",
      class: _normalizeClass(["side-menu-item", { 'side-menu-item-active': _unref(isServicesActive) }]),
      "aria-label": _ctx.$t('Services')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["side-menu-item-icon", { 'side-menu-item-icon-active': _unref(isServicesActive) }])
        }, _hoisted_6, 2),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('Services')), 1)
      ]),
      _: 1
    }, 8, ["class", "aria-label"])
  ]))
}
}

})